<template>
  <div id="eventRightThree">
    <div class="title">
      <span>单位</span>
      <span>事件解决率</span>
      <span>事件数量</span>
    </div>
    <div class="content" v-for="item in list" :key="item">
      <span>{{ item.name }}</span>
      <span>{{ item.lv }}</span>
      <span>{{ item.value }}</span>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
import {
  analyseeventdoneCount,
  analyseeventregion
} from "@/api/dataAnalysis/eventAnalysis.js";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      list: []
    });
    const refData = toRefs(data);
    const analyseeventdoneCountAxios = async () => {
      const ress = await analyseeventregion({ type: 0 });
      const res = await analyseeventdoneCount({ type: 0 });
      console.log(ress, res, 6666666);
      const obj1 = {};
      const obj2 = {};
      ress.data.forEach(item => {
        obj1[item.name] = item.value;
      });
      res.data.forEach(item => {
        obj2[item.name] = item.value;
      });
      const arr = [];
      for (const key in obj1) {
        if (obj1) {
          console.log(obj1[key], obj2[key]);
          const obj = {
            lv:
              obj1[key] !== 0 && obj2[key] !== 0
                ? (obj1[key] / obj2[key]) * 100
                : 0,
            name: key,
            value: obj1[key]
          };
          arr.unshift(obj);
        }
      }
      arr.sort((a, b) => {
        return b.lv - a.lv;
      });
      data.list = arr.slice(0, 3).map(item => {
        item.lv = item.lv + "%";
        return item;
      });
      console.log(arr, 5555555);
      // ress.data.forEach(async item => {
      //   item.lv = (item.value / res.data[0].value) * 100 + "%";
      //   data.list.push(item);
      // });
    };
    analyseeventdoneCountAxios();
    return { ...refData };
  }
});
</script>
<style lang="scss" scoped>
#eventRightThree {
  width: 100%;
  height: 80%;
  display: flex;
  flex-direction: column;
  .title {
    display: flex;
    align-items: center;
    // justify-content: space-around;
    color: #02bad3;
    height: 50px;
    background-color: #1a507a;
    span {
      display: inline-block;
      width: 33%;
      text-align: center;
    }
  }
  .content {
    display: flex;
    flex: 1;
    align-items: center;
    // justify-content: space-around;
    color: #fff;
    background-color: #092956;
    span {
      display: inline-block;
      width: 33%;
      text-align: center;
    }
  }
}
</style>
